var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"another-person-photo"},[_vm._v(_vm._s(_vm.text)),(_vm.showShareIcons)?_c('div',{staticClass:"another-person-photo__share"},[_c('right-aside-social')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }